import { Component } from '@angular/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})

export class UserProfileComponent {

  get userIconClass(): string {
    return localStorage.getItem("usericon");
  }

  get userName(): string {
    return localStorage.getItem("username");
  }

  constructor(public authenticationService: AuthenticationService) {
  }
}
